var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 50715"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 16357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M2.92 15.381a2.809 2.809 0 0 1-2.073-.851 2.824 2.824 0 0 1-.845-2.067 2.813 2.813 0 0 1 .851-2.067 2.814 2.814 0 0 1 2.067-.851V6.191a1.57 1.57 0 0 1 .491-1.145 1.57 1.57 0 0 1 1.145-.491h4.527a2.809 2.809 0 0 1 .851-2.073 2.824 2.824 0 0 1 2.068-.845 2.815 2.815 0 0 1 2.067.851 2.814 2.814 0 0 1 .851 2.067h4.527a1.57 1.57 0 0 1 1.145.491 1.57 1.57 0 0 1 .491 1.145v3.354a2.809 2.809 0 0 1 2.073.851 2.823 2.823 0 0 1 .846 2.067 2.814 2.814 0 0 1-.851 2.067 2.814 2.814 0 0 1-2.067.851v5.345a1.57 1.57 0 0 1-.491 1.145 1.57 1.57 0 0 1-1.145.491H4.556a1.57 1.57 0 0 1-1.145-.491 1.57 1.57 0 0 1-.491-1.145Zm5.351-2.727a1.037 1.037 0 0 0 .771-.32 1.069 1.069 0 0 0 .314-.777 1.037 1.037 0 0 0-.32-.771 1.069 1.069 0 0 0-.777-.314 1.037 1.037 0 0 0-.771.32 1.069 1.069 0 0 0-.314.777 1.037 1.037 0 0 0 .32.771 1.068 1.068 0 0 0 .777.314Zm7.472 0a1.037 1.037 0 0 0 .771-.32 1.069 1.069 0 0 0 .314-.777 1.037 1.037 0 0 0-.32-.771 1.069 1.069 0 0 0-.777-.314 1.037 1.037 0 0 0-.771.32 1.069 1.069 0 0 0-.314.777 1.037 1.037 0 0 0 .32.771 1.068 1.068 0 0 0 .777.314Zm-8.324 5.209h9.163v-1.636H7.42Zm-2.863 2.863h14.89V6.191H4.556Zm0 0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiRobot);
export default __webpack_public_path__ + "static/media/ai-robot.58846e03c0a0370f546322e3dd22ca30.svg";
export { ForwardRef as ReactComponent };